import axios from "axios";

const BASE_URL = "https://backsanpancracio.us-3.evennode.com";

// ✅ GET: Traer todas las localidades
export const getLocalidades = async () => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/localidades`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener localidades",
    };
  }
};

// ✅ GET: Traer una localidad por ID
export const getLocalidadId = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/localidades/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener la localidad",
    };
  }
};

// ✅ POST: Crear nueva localidad
export const postLocalidad = async (localidadData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/localidades`;

  try {
    const resp = await axios.post(url, localidadData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear localidad",
    };
  }
};

// ✅ PUT: Actualizar localidad
export const putLocalidad = async (id, localidadData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/localidades/${id}`;

  try {
    const resp = await axios.put(url, localidadData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar localidad",
    };
  }
};

// ✅ DELETE: Desactivar o eliminar localidad
export const deleteLocalidad = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/localidades/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar localidad",
    };
  }
};
